import React from 'react';
import { Button, IconButton } from '@mui/material';
import { Add, Refresh } from '@mui/icons-material';

interface StandardActionsProps {
  onAdd?: () => void;
  onRefresh?: () => void;
  addButtonText?: string;
  addButtonIcon?: React.ReactNode;
  refreshTooltip?: string;
  disabled?: boolean;
  customActions?: React.ReactNode;
}

const StandardActions: React.FC<StandardActionsProps> = ({
  onAdd,
  onRefresh,
  addButtonText = 'Add',
  addButtonIcon = <Add />,
  refreshTooltip = 'Refresh list',
  disabled = false,
  customActions
}) => {
  return (
    <>
      {onAdd && (
        <Button
          variant="contained"
          startIcon={addButtonIcon}
          onClick={onAdd}
          disabled={disabled}
        >
          {addButtonText}
        </Button>
      )}
      
      {onRefresh && (
        <IconButton 
          onClick={onRefresh}
          title={refreshTooltip}
          disabled={disabled}
        >
          <Refresh />
        </IconButton>
      )}

      {customActions}
    </>
  );
};

export default StandardActions;
